export default "__VITE_ASSET__DwoMEJYf__"